import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const notificationUtils = (type: string, message: string, duration: number = 3000) => {
  const position = "top-center";
  const colorText = "text-white";
  toast(message, {
    position,
    hideProgressBar: true,
    autoClose: duration,
    className: `bg-${type} ${colorText}`,
  });

  return () => {
    toast.dismiss();
  };
};

export { notificationUtils };
